const types = {
  template: 'template',
  document: 'document',
}

types.all = Object.keys(types);

export default types;
